import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const GradFairsLinksLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "GradFairsLinks" */
      './GradFairsLinks.dynamic'
    ),
  loading: LoadingPageLoadable,
});
